/* <sku-copy>: the SKU with a copy button — the product page and the quick view. Block-scoped so a
   second copy of this file (both load it on the product page) is a no-op, not a redeclaration. */
if (!customElements.get("sku-copy")) {
class SkuCopy extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this._timeout = null;
  }

  connectedCallback() {
    this.sku = this.getAttribute("sku") || "";
    this.successText = this.getAttribute("success-text") || "✔ הועתק";
    this.iconSvg = this.getAttribute("icon") || "";
    this.successIconSvg = this.getAttribute("success-icon") || "";

    this.render();
    this.button = this.querySelector("button");
    this.iconEl = this.querySelector(".icon");
    this.feedbackEl = this.querySelector(".sku-feedback");

    this.button.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.onClick);
    clearTimeout(this._timeout);
  }

  render() {
    this.innerHTML = `
      <button 
        type="button" 
        class="sku-copy-btn btn btn-link p-0 m-0 align-baseline text-dark text-decoration-none d-inline-flex align-items-center gap-1"
        aria-label="העתקת מק״ט"
      >
        <span class="icon d-inline-flex align-items-center">
          ${this.iconSvg}
        </span>
        <strong>מק״ט:</strong>
        <span class="sku-text">${this.sku}</span>
      </button>

      <div class="sku-feedback" style="
        position: absolute;
        background: #000;
        color: #fff;
        padding: 4px 8px;
        border-radius: 6px;
        font-size: 12px;
        opacity: 0;
        pointer-events: none;
        transform: translateY(-6px);
        transition: opacity .25s ease, transform .25s ease;
      ">
        ${this.successText}
      </div>
    `;
  }

  async onClick() {
    try {
      await navigator.clipboard.writeText(this.sku);
      this.showFeedback();
      this.flashIcon();
    } catch (err) {
      console.error("[SkuCopy] clipboard error:", err);
    }
  }

  flashIcon() {
    if (!this.successIconSvg) return;

    const original = this.iconEl.innerHTML;
    this.iconEl.innerHTML = this.successIconSvg;

    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      this.iconEl.innerHTML = original;
    }, 1200);
  }

  showFeedback() {
    const box = this.feedbackEl;
    if (!box) return;

    box.style.opacity = "1";
    box.style.transform = "translateY(-12px)";

    clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      box.style.opacity = "0";
      box.style.transform = "translateY(-6px)";
    }, 1200);
  }

  set skuValue(newSku) {
    this.sku = newSku;
    this.querySelector(".sku-text").textContent = newSku;
  }
}

  customElements.define("sku-copy", SkuCopy);
}
